const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeriesManifestationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "custom: series"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 38H36",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      stroke: "#8C271E",
      strokeOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 3,
    y: 9,
    width: 42,
    height: 25,
    rx: 1,
    strokeWidth: 2,
    style: {
      fill: "#8C271E",
      stroke: "#8C271E",
      opacity: 0.8
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesManifestationRed);
export default __webpack_public_path__ + "static/media/series_manifestation_red.36e2249fc705f301023131fbe9b9e644.svg";
export { ForwardRef as ReactComponent };